<div class="barlow flex flex-col gap-1 p-2.5">
  @if (inCart && cartService.currentStep < 2 && !inOrderDetail) {
    <div class="menu-item-container" (click)="editFolder()">
      <ion-icon src="../../../assets/icon/lapizEditar.svg"></ion-icon>
      <span>Editar carpeta</span>
    </div>
    <div class="divider"></div>
  }

  @if (cartService.currentStep < 3 && !inOrderDetail) {
    <div class="menu-item-container" (click)="changeFolderName()">
      <ion-icon src="assets/icon/rename.svg"></ion-icon>
      <span>Renombrar carpeta</span>
    </div>
    <div class="divider"></div>
  }

  @if ((inCart && !modal) || inOrderDetail) {
    <div class="menu-item-container" (click)="viewDocs()">
      <ion-icon src="../../../assets/icon/eye.svg"></ion-icon>
      <span>Ver documentos</span>
    </div>
    @if (!inOrderDetail) {
      <div class="divider"></div>
    }
  }

  @if (!inOrderDetail) {
    <div class="menu-item-container" (click)="changeComment()">
      <ion-icon src="assets/icon/chat-bubble.svg"></ion-icon>
      <span>Añadir un comentario</span>
    </div>
    <div class="divider"></div>
  }

  @if (cartService.currentStep < 2 && !inOrderDetail) {
    <div class="menu-item-container" (click)="duplicateFolder()">
      <ion-icon src="assets/icon/doubleFolder.svg"></ion-icon>
      <span>Duplicar carpeta</span>
    </div>
    <div class="divider"></div>
  }

  @if (cartService.currentStep < 2 && !inOrderDetail) {
    <div class="menu-item-container delete-folder" (click)="removePrintGroup()">
      <ion-icon src="assets/icon/eliminar.svg"></ion-icon>
      <span>Eliminar carpeta</span>
    </div>
  }
</div>
